var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnbekMansapLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.3734 13.4166C30.0314 13.4166 32.9967 10.4132 32.9967 6.70828C32.9967 3.0034 30.0314 0 26.3734 0C22.7154 0 19.75 3.0034 19.75 6.70828C19.75 10.4132 22.7154 13.4166 26.3734 13.4166Z",
    fill: "url(#paint0_linear_21679_27647)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0667 11.3834C18.0116 11.3834 20.399 8.9654 20.399 5.9827C20.399 2.99999 18.0116 0.582031 15.0667 0.582031C12.1217 0.582031 9.73438 2.99999 9.73438 5.9827C9.73438 8.9654 12.1217 11.3834 15.0667 11.3834Z",
    fill: "url(#paint1_linear_21679_27647)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8091 23.0474C23.573 23.0474 25.8136 20.7781 25.8136 17.9788C25.8136 15.1795 23.573 12.9102 20.8091 12.9102C18.0453 12.9102 15.8047 15.1795 15.8047 17.9788C15.8047 20.7781 18.0453 23.0474 20.8091 23.0474Z",
    fill: "url(#paint2_linear_21679_27647)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.97564 8.4768C4.61904 8.4768 5.95128 7.12748 5.95128 5.46301C5.95128 3.79854 4.61904 2.44922 2.97564 2.44922C1.33224 2.44922 0 3.79854 0 5.46301C0 7.12748 1.33224 8.4768 2.97564 8.4768Z",
    fill: "url(#paint3_linear_21679_27647)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3865 21.2626C12.2224 21.2626 13.7106 19.7553 13.7106 17.896C13.7106 16.0366 12.2224 14.5293 10.3865 14.5293C8.55073 14.5293 7.0625 16.0366 7.0625 17.896C7.0625 19.7553 8.55073 21.2626 10.3865 21.2626Z",
    fill: "url(#paint4_linear_21679_27647)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4801 31.7794C19.5575 31.7794 21.2415 30.0737 21.2415 27.9698C21.2415 25.8658 19.5575 24.1602 17.4801 24.1602C15.4028 24.1602 13.7188 25.8658 13.7188 27.9698C13.7188 30.0737 15.4028 31.7794 17.4801 31.7794Z",
    fill: "url(#paint5_linear_21679_27647)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_21679_27647",
    x1: 26.3734,
    y1: 0,
    x2: 26.3734,
    y2: 13.4165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEE0FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7983EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_21679_27647",
    x1: 15.0667,
    y1: 0.582031,
    x2: 15.0667,
    y2: 11.3834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEE0FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7983EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_21679_27647",
    x1: 20.8091,
    y1: 12.9103,
    x2: 20.8091,
    y2: 23.0474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEE0FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7983EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_21679_27647",
    x1: 2.97564,
    y1: 2.44922,
    x2: 2.97564,
    y2: 8.4768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEE0FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7983EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_21679_27647",
    x1: 10.3865,
    y1: 14.5293,
    x2: 10.3865,
    y2: 21.2627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEE0FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7983EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_21679_27647",
    x1: 17.4801,
    y1: 24.1602,
    x2: 17.4801,
    y2: 31.7793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEE0FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7983EA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnbekMansapLogo);
export default __webpack_public_path__ + "static/media/enbek-mansap-logo.10bc0ff8ea7ccd949e3df2e837c3673e.svg";
export { ForwardRef as ReactComponent };